module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'u92inaqz',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
